<template>
  <iframe
    v-if="tag === 'iframe'"
    :title="alt"
    :width="width"
    :height="height"
    :class="classes"
    :style="style"
    :src="src"
  />
  <div
    v-else
    class="tw-max-w-full"
    style="height: 360px; width: 690px;"
  >
    <video
      :width="width"
      :height="height"
      :autoplay="autoplay"
      :controls="controls"
      :loop="loop"
      :muted="muted"
      :poster="poster"
      :oncanplay="oncanplay"
      class="tw-max-w-full tw-max-h-full"
    >
      <source :src="src" :type="`video/${videoFormat}`" />
    </video>
  </div>
</template>

<script>
import './vue-video.scss';

export default {
  name: 'VueVideo',
  props: {
    tag: {
      type: String,
      required: true,
      default: "iframe",
      validator(value) {
        return ['iframe', 'video',].includes(value);
      }
    },
    alt: {
      type: String,
      required: true,
    },
    height: {
      type: String,
      required: false
    },
    width: {
      type: String,
      required: false
    },
    fullWidth: {
      type: Boolean,
      default: false,
      required: false
    },
    src: {
      type: String,
      required: true,
    },
    videoFormat: {
      type: String,
      required: false,
      default: "mp4"
    },
    autoplay: {
      type: Boolean,
      required: false,
      default: true
    },
    controls: {
      type: Boolean,
      required: false,
      default: true
    },
    loop: {
      type: Boolean,
      required: false,
      default: false
    },
    muted: {
      type: Boolean,
      required: false,
      default: true
    },
    poster: {
      type: String,
      required: false,
    },
    extraClasses: {
      type: Object,
      required: false
    },
  },
  computed: {
    oncanplay() {
      return this.muted ? 'this.muted=true' : null;
    },
    classes() {
      return {
        [`tw-w-full`]: this.fullWidth,
        ...this.extraClasses
      };
    },
    style() {
      return {
        height: this.height
      };
    },
  }
};
</script>
